import React from "React"

const Video = ({src, className, autoPlay}) => {


  return (
    <video src={src}  className={className} controls autoPlay={autoPlay} loop={true} muted={true}></video>
  )
}

Video.defaultProps = {
  src: '',
  className: 'videos',
  autoPlay:'',
}


export default Video
